function isIndexedDBAvailable() {
	try {
		if (!window.indexedDB) {
			return false;
		}
		return true;
	} catch (error) {
		return false;
	}
}

function openDatabase(name) {
	return new Promise((resolve, reject) => {
		const request = indexedDB.open(name, 1);

		request.onupgradeneeded = (event) => {
			const db = event.target.result;
			db.createObjectStore("dataStore");
		};

		request.onsuccess = (event) => {
			resolve(event.target.result);
		};

		request.onerror = (event) => {
			reject(event.target.error);
		};
	});
}

async function saveDataToIndexedDB(dbName, key, data) {
	if (!isIndexedDBAvailable()) {
		throw new Error("IndexedDB is not available");
	}

	const db = await openDatabase(dbName);
	const tx = db.transaction("dataStore", "readwrite");
	const store = tx.objectStore("dataStore");
	const request = store.put({ data, timestamp: Date.now() }, key);

	return new Promise((resolve, reject) => {
		request.onsuccess = () => {
			resolve();
		};

		request.onerror = (event) => {
			reject(event.target.error);
		};
	});
}

async function getDataFromIndexedDB(dbName, key) {
	if (!isIndexedDBAvailable()) {
		throw new Error("IndexedDB is not available");
	}

	if (!key) {
		throw new Error("Key not specified");
	}

	const db = await openDatabase(dbName);
	const tx = db.transaction("dataStore", "readonly");
	const store = tx.objectStore("dataStore");
	const request = store.get(key);

	return new Promise((resolve, reject) => {
		request.onsuccess = (event) => {
			const storedData = event.target.result;

			if (storedData) {
				const now = Date.now();
				const oneDayInMilliseconds = 24 * 60 * 60 * 1000;

				if (now - storedData.timestamp <= oneDayInMilliseconds) {
					resolve(storedData.data);
				} else {
					deleteIndexedDB(dbName)
					.then(() => {
					  	resolve(null);
					})
					.catch((error) => {
						reject(error);
					});
				}
			} else {
				resolve(null);
			}
		};

		request.onerror = (event) => {
			reject(event.target.error);
		};
	});
}


async function deleteIndexedDB(dbName) {
	if (!isIndexedDBAvailable()) {
		throw new Error("IndexedDB is not available");
	}

	return new Promise((resolve, reject) => {
		const request = indexedDB.deleteDatabase(dbName);

		request.onsuccess = () => {
			resolve();
		};

		request.onerror = (event) => {
			reject(event.target.error);
		};
	});
}


async function deleteAllIndexedDB() {
	if (!isIndexedDBAvailable()) {
		throw new Error("IndexedDB is not available");
	}

	const databases = await indexedDB.databases();

	databases.forEach((database) => {
		indexedDB.deleteDatabase(database.name);
	});
}

export { openDatabase, saveDataToIndexedDB, getDataFromIndexedDB, deleteIndexedDB, isIndexedDBAvailable, deleteAllIndexedDB  };
